import Avatar from './Avatar';
import { TAvatarProps } from './Avatar.types';

export type { TAvatarProps };
export default Avatar;
